import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'

export const Route = createFileRoute('/_app/pharma/explorer')({
  component: PharmaExplorerPage,
})

function PharmaExplorerPage() {
  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_SHARED_WS_ADDRESS}
      username={import.meta.env.VITE_WS_USERNAME}
      password={import.meta.env.VITE_WS_PASSWORD}
      rootName="Biomed"
      topicFilters="Biomed/#"
      clientIdPrefix="stories_uns_pharma"
    />
  )
}
